import { integer, object } from 'superstruct';

/** Any object that has an id. */
export const IdObject = object({
  id: integer()
});